import { render, staticRenderFns } from "./DynamicPage.vue?vue&type=template&id=f20ab8f8&scoped=true&"
import script from "./DynamicPage.vue?vue&type=script&lang=js&"
export * from "./DynamicPage.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPage.vue?vue&type=style&index=0&id=f20ab8f8&scoped=true&lang=css&"
import style1 from "./DynamicPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20ab8f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VTab,VTabItem,VTabs,VTabsSlider})
